import {
    Box,
    Stack,
    Typography,
} from '@mui/material';


/* *************************************************************************************************************** */ 
/* *************************************************************************************************************** */ 

export const DescriptionsItem = ({ label, value,  }) => {
    return (
      <Stack direction={'row'} flexGrow={1} flexShrink={0} flexBasis={'50%'} borderBottom={theme => `1px solid ${theme.palette.divider}`}>
        <Typography variant={'body1'} fontWeight={700} width={160} flexGrow={0} flexShrink={0} flexBasis={'auto'} px={3} py={2} display={'flex'} alignItems={'center'} sx={{ backgroundColor: theme => theme.palette.grey[300] }}>{ label }</Typography>
        <Typography px={3} py={2} width={`calc(100% - 160px)`} display={'flex'} alignItems={'center'} sx={{ wordBreak: 'break-all' }}>{ value }</Typography>
      </Stack>
    )
};

export const Descriptions = ({ title, subtitle, children, spacing = 1 }) => {
    return (
      <Stack spacing={spacing} position={'relative'}>
        <Box
          pl={1.5}
          display={'flex'}
          alignItems={'center'}
          sx={{
            '&:before': {
              content: '""',
              width: 4,
              height: 16,
              display: 'block',
              position: 'absolute',
              left: 0,
              backgroundColor: theme => theme.palette.primary.main
            }
          }}
        >
          <Typography variant={'h6'}>
            { title }
          </Typography>
          {
            subtitle && (
              <Typography flex={1} variant={'h6'} color={'text.secondary'} fontWeight={400}>
                { subtitle }
              </Typography>
            )
          }
        </Box>
        {
          children && (
            <Box
              // display={'grid'}
              // gridTemplateColumns={`repeat(auto-fill, minmax(auto, 50%))`}
              display={'flex'}
              flexWrap={'wrap'}
            >
              { children }
            </Box>
          )
        }
      </Stack>
    )
};


/* *************************************************************************************************************** */ 
/* *************************************************************************************************************** */ 


export const DescriptionItem = ({ children, ...others }) => {
    return (
      <Box display={'flex'} alignItems={'center'} {...others}>
        { children }
      </Box>
    )
};



export const DescriptionLabel = ({ children }) => {
    return (
      <Typography component={'span'} variant={'body1'} color={'text.secondary'} display={'flex'} alignItems={'center'} gap={1}>
        { children }
      </Typography>
    )
};
  
export const DescriptionValue = ({ children }) => {
    return (
      <Typography component={'span'} variant={'body1'}>
        { children }
      </Typography>
    )
};

/* *************************************************************************************************************** */ 
/* *************************************************************************************************************** */ 